define(["require", "exports", "jquery", "knockout", "log", "../../utils/urls", "../../utils/tools", "../../utils/kendoUtils", "../../utils/dateUtils", "../../models/UserContext", "../phoneNumbers/phoneNumberActions"], function (require, exports, $, ko, log, urls_1, tools, KendoUtils, DateUtils, UserContext, NumberActions) {
    "use strict";
    var UnbilledCdr = /** @class */ (function () {
        function UnbilledCdr() {
            this.filterByEndDate = ko.observable(DateUtils.today());
            this.filterByAny = ko.observable("");
            this.filterApplied = ko.observable(false);
            this.filterInProgress = ko.observable(false);
            this.userCanAddPhone = ko.observable(UserContext.hasAccess("Admin,PhoneNumbers.Edit,PhoneNumbers.Delete"));
            this.canExport = ko.observable(UserContext.hasAccess("Admin,Accounting.Export"));
            this.isAdmin = ko.observable(UserContext.hasAccess("Admin"));
            this.phoneActions = new NumberActions();
        }
        UnbilledCdr.prototype.init = function () {
            var self = this;
            $("#page-title").text("Unbilled CDR's Report");
            tools.ajaxGet({
                url: "/UnbilledCdr/GetLookupData",
                success: function (data) {
                    if (data.Success) {
                        self.reportLookupLists = data.Data.lookupLists;
                    }
                    else {
                        log.error(data.Error);
                    }
                    self.initGrid(self.reportLookupLists.GridStructures.UnbilledCdrSummaryStructure);
                    ko.applyBindings(self, document.getElementById("ko-main-content"));
                    $("#contextLoader").hide();
                    $("#mainContext").show();
                    self.phoneActions.savePhoneCallback = function (data) {
                        tools.ajaxPost({
                            url: "/UnbilledCdr/AssignPhoneToCustomer",
                            data: { callerId: data.Number },
                            success: function (result) {
                                if (result.Success) {
                                    self.mainTable.refresh();
                                }
                                else {
                                    log.error(result.Error);
                                }
                            }
                        });
                    };
                }
            });
        };
        UnbilledCdr.prototype.initGrid = function (gridStructure) {
            var self = this;
            var columns = gridStructure.columns;
            //add actions column
            var actionsColumn = {
                field: "",
                width: "100px",
                template: function (dataItem) {
                    var html = "";
                    html += '<a class="btn btn-sm btn-primary btn-view" title="Open Details" href="#"><i class="fa fa-eye"></i></a>';
                    if (!dataItem.CustomerId && self.userCanAddPhone()) {
                        html += '&nbsp;<a class="btn btn-sm btn-yellow btn-edit" title="Assign Number" href="#"><i class="fa fa-edit"></i></a>';
                    }
                    if (self.isAdmin) {
                        html += '&nbsp;<a class="btn btn-sm btn-danger btn-mark-as-billed" title="Mark As Billed" href="#"><i class="fa fa-ban"></i></a>';
                    }
                    return html;
                }
            };
            columns.push(actionsColumn);
            self.mainTable = new KendoUtils.KendoUtils();
            var gridOptions = {
                dataSourceOptions: {
                    transport: {
                        read: {
                            url: "/UnbilledCdr/GetCdrSummaryData",
                            type: "POST",
                            data: function () {
                                self.filterInProgress(true);
                                var data = {};
                                data.filterText = self.filterByAny();
                                data.endDate = DateUtils.toIsoStringDate(self.filterByEndDate());
                                data.providers = self.multipleProviderSelector.value().join();
                                data.callTypes = self.multipleCallTypeSelector.value().join();
                                data.customerIds = self.multipleCustomerSelector.value().join();
                                return data;
                            },
                            dataType: "json"
                        }
                    },
                    aggregate: gridStructure.aggregate,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                    serverAggregates: true,
                    schema: {
                        model: gridStructure.model,
                        data: function (response) { return response.Data; },
                        total: "Total",
                        aggregates: "Aggregates",
                        errors: "Errors"
                    },
                    sort: { field: "CallerId", dir: "asc" }
                },
                gridOptions: {
                    toolbar: kendo.template($("#cdrSummaryReport-toolbar-template").html()),
                    columns: columns,
                    autoBind: false,
                    height: "400px",
                    scrollable: true,
                    resizable: true,
                    dataBound: function () {
                        self.filterInProgress(false);
                        $("button[data-action='applyFilter']").button("reset");
                    }
                },
                enableExport: {
                    entityName: "UnbilledCdrReport",
                    title: "Unbilled Cdr Report",
                    enablePdf: false
                },
                allowBulkEdits: {
                    enabled: self.canExport()
                },
                autoHeight: {
                    totalOffset: 46 + 41 + 3
                },
                enableStickyHeader: true,
                gridId: "tblUnbilledCdrSummary",
                showPagerOnTop: false,
                controller: self
            };
            self.mainTable.initGrid(gridOptions);
            $("#tblUnbilledCdrSummary table").css("width", "");
            $("#tblUnbilledCdrSummary tbody").on("click", ".btn-view", function (event) {
                var dataItem = KendoUtils.KendoUtils.getGridRowDataItem(event.currentTarget);
                var gridHeader = $("#tblUnbilledCdrSummary .k-grid-header").clone();
                var row = $(event.currentTarget).closest("tr");
                var rowClone = row.clone();
                $(".check-row", row).prop("checked", true);
                gridHeader.find("col:first").remove();
                gridHeader.find("col:last").remove();
                gridHeader.find("tr:first").find("th:first").remove();
                gridHeader.find("tr:first").find("th:last").remove();
                rowClone.find("td:first").remove();
                rowClone.find("td:last").remove();
                self.openDetails(dataItem, rowClone, gridHeader, row);
                event.preventDefault();
            }).on("click", ".btn-edit", function (event) {
                var dataItem = KendoUtils.KendoUtils.getGridRowDataItem(event.currentTarget);
                self.phoneActions.editPhoneNumber(null, dataItem.CallerId, null, null, dataItem.BTN);
                event.preventDefault();
            }).on("click", ".btn-mark-as-billed", function (event) {
                var dataItem = KendoUtils.KendoUtils.getGridRowDataItem(event.currentTarget);
                self.markCdrAsBilledConfirm(dataItem);
                event.preventDefault();
            });
            self.mainTable.setExportDetailsDataSource({
                transport: {
                    read: {
                        url: "/UnbilledCdr/GetCdrDetailsData",
                        type: "POST",
                        dataType: "json"
                    }
                },
                schema: {
                    model: self.reportLookupLists.GridStructures.CallDetailRecordStructure.model,
                    data: function (response) { return response.Data; },
                    total: "Total",
                    //aggregates: "Aggregates",
                    errors: "Errors"
                },
                serverPaging: true,
                serverAggregates: false
            });
            self.mainTable.hasDetailsToExport = true;
            self.mainTable.exportFilterMap = [
                { filterField: "callerId", masterRowField: "CallerId" },
                { filterField: "providerId", masterRowField: "ProviderId" },
                { filterField: "callType", masterRowField: "CallType" },
                { filterField: "endDate", value: function () { return DateUtils.toIsoStringDate(self.filterByEndDate()); } },
                { filterField: "providers", value: function () { return self.multipleProviderSelector.value().join(); } },
                { filterField: "callTypes", value: function () { return self.multipleCallTypeSelector.value().join(","); } },
                { filterField: "customerIds", value: function () { return self.multipleCustomerSelector.value().join(","); } }
            ];
            self.mainTable.detailsGridStructure = self.reportLookupLists.GridStructures.CallDetailRecordStructure;
            self.multipleCallTypeSelector = $("#filterByCallTypeInput").kendoMultiSelect({
                autoBind: false,
                valuePrimitive: true,
                filter: "contains",
                dataTextField: "Text",
                dataValueField: "Value",
                autoClose: false,
                tagMode: "single",
                dataSource: {
                    data: self.reportLookupLists.CallTypes
                },
                dataBound: function () {
                    $(window).trigger("resize");
                },
                change: function (e) {
                    self.filterApplied(false);
                    $(window).trigger("resize");
                }
            }).data("kendoMultiSelect");
            self.multipleProviderSelector = $("#filterByProviderInput").kendoMultiSelect({
                autoBind: false,
                valuePrimitive: true,
                filter: "contains",
                dataTextField: "Text",
                dataValueField: "Value",
                autoClose: false,
                tagMode: "single",
                dataSource: {
                    data: self.reportLookupLists.CdrProviders
                },
                dataBound: function () {
                    $(window).trigger("resize");
                },
                change: function (e) {
                    self.filterApplied(false);
                    $(window).trigger("resize");
                }
            }).data("kendoMultiSelect");
            self.filterByEndDate.subscribe(function () {
                self.filterApplied(false);
            });
            self.filterByAny.subscribe(function () {
                self.filterApplied(false);
            });
            self.multipleCustomerSelector = $("#filterByCustomerInput").kendoMultiSelect({
                autoBind: false,
                valuePrimitive: true,
                filter: "contains",
                dataTextField: "Text",
                dataValueField: "Value",
                autoClose: false,
                tagMode: "single",
                dataSource: {
                    transport: {
                        read: {
                            url: "/Customers/GetCustomersLookup",
                            type: "POST",
                            dataType: "json"
                        }
                    },
                    schema: {
                        data: function (response) { return response.Data; },
                        total: "Total"
                    },
                    serverFiltering: true
                },
                dataBound: function () {
                    $(window).trigger("resize");
                },
                change: function (e) {
                    self.filterApplied(false);
                    $(window).trigger("resize");
                }
            }).data("kendoMultiSelect");
            self.filterByEndDate.subscribe(function () {
                self.filterApplied(false);
            });
            self.filterByAny.subscribe(function () {
                self.filterApplied(false);
            });
            $("#tblUnbilledCdrSummary .grid-filter-form").on("keyup", function (e) {
                if (e.keyCode === 13) {
                    self.applyFilter();
                }
            });
        };
        UnbilledCdr.prototype.openDetails = function (dataItem, masterRow, masterHeader, row) {
            var self = this;
            tools.editModal({
                title: "Call Detail Records for - " + dataItem.CallerId,
                modalClass: "full-width",
                type: "info",
                hideFooter: true,
                modalOptions: {},
                buttonTitle: "Close",
                save: function (event, modal) {
                    $(modal).modal("hide");
                },
                close: function () {
                    $(".check-row", row).prop("checked", false);
                },
                opened: function (modal) {
                    $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'call-details-template', data: self }\"></div>");
                    ko.applyBindings(self, modal);
                    self.initCdrGrid(self.reportLookupLists.GridStructures.CallDetailRecordStructure, dataItem.CallerId, dataItem.ProviderId, dataItem.CallType);
                    masterRow.appendTo($("thead", masterHeader));
                    masterHeader.insertBefore($(".k-grid-header", modal));
                }
            });
        };
        UnbilledCdr.prototype.initCdrGrid = function (gridStructure, callerId, providerId, callType) {
            var self = this;
            var grid = new KendoUtils.KendoUtils();
            var gridOptions = {
                dataSourceOptions: {
                    transport: {
                        read: {
                            url: "/UnbilledCdr/GetCdrDetailsData",
                            type: "POST",
                            data: function () {
                                var data = {
                                    callerId: callerId,
                                    providerId: providerId,
                                    callType: callType,
                                    endDate: DateUtils.toIsoStringDate(self.filterByEndDate()),
                                    providers: self.multipleProviderSelector.value().join(),
                                    callTypes: self.multipleCallTypeSelector.value().join(),
                                    customerIds: self.multipleCustomerSelector.value().join()
                                };
                                return data;
                            },
                            dataType: "json"
                        }
                    },
                    schema: {
                        model: gridStructure.model
                    },
                    aggregate: gridStructure.aggregate,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                    pageSize: 20
                },
                gridOptions: {
                    toolbar: kendo.template($("#cdrDetails-toolbar-template").html()),
                    columns: gridStructure.columns,
                    autoBind: true,
                    height: "400px",
                    scrollable: true,
                    dataBound: function () {
                    }
                },
                allowBulkEdits: {
                    enabled: false
                },
                gridId: "tblCdrDetails",
                showPagerOnTop: false,
                autoHeight: {
                    totalOffset: 56 + 21 + 30 + 7
                }
            };
            grid.initGrid(gridOptions);
            if (self.canExport()) {
                $("#tblCdrDetails .js-export").on("click", function () {
                    self.mainTable.exportTo(true);
                });
            }
            else {
                $("#tblCdrDetails .js-export").hide();
            }
        };
        UnbilledCdr.prototype.markCdrAsBilled = function (dataItem) {
            var self = this;
            var data = {
                callerId: dataItem.CallerId,
                btn: dataItem.BTN,
                callType: dataItem.CallType,
                providerId: dataItem.ProviderId,
                customerId: dataItem.CustomerId,
            };
            data["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/UnbilledCdr/MarkCdrAsBilled",
                data: data
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Action successfully proceeded");
                    self.mainTable.refresh();
                }
            }).always(function () {
                //btn.button("reset");
            });
        };
        UnbilledCdr.prototype.markCdrAsBilledConfirm = function (dataItem) {
            var self = this;
            tools.confirmModal({
                title: "Mark As Billed",
                text: "Are you sure you want to mark as billed?",
                buttonTitle: "Mark As Billed",
                type: "danger",
                modalOptions: {}
            }, function (modal) {
                $(modal).modal("hide");
                self.markCdrAsBilled(dataItem);
            });
        };
        UnbilledCdr.prototype.applyFilter = function () {
            var self = this;
            if (!self.filterApplied() && !self.filterInProgress()) {
                $("button[data-action='applyFilter']").button("loading");
                self.mainTable.refresh();
                self.filterApplied(true);
            }
        };
        UnbilledCdr.prototype.clearFilter = function () {
            var self = this;
            self.filterByEndDate(DateUtils.today());
            self.filterByAny("");
            self.multipleCallTypeSelector.value([]);
            self.multipleCallTypeSelector.trigger("change");
            self.multipleProviderSelector.value([]);
            self.multipleProviderSelector.trigger("change");
            self.multipleCustomerSelector.value([]);
            self.multipleCustomerSelector.trigger("change");
        };
        UnbilledCdr.prototype.exportTo = function () {
            var self = this;
            if (self.canExport()) {
                self.mainTable.exportTo();
            }
        };
        return UnbilledCdr;
    }());
    setTimeout(function () {
        if (urls_1.urls.startsWith("/UnbilledCdr/Index")) {
            log.log("Initialize Unbilled CDR report");
            $(function () {
                (new UnbilledCdr()).init();
            });
        }
    }, 0);
    return UnbilledCdr;
});
//# sourceMappingURL=unbilled-cdr.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/reports/unbilled-cdr.js
// module id = 264
// module chunks = 2